import * as React from "react"

import { cn } from "@/utils/cn"
import { FormikInputProps } from "./input"
import { useFormikContext } from "formik"
import { ReloadIcon } from "@radix-ui/react-icons"
import { Label } from "./label"
import { FIELD_ERROR_CLASS, FieldErrorMessage, useFieldError } from "./field-error"
import { Col } from "../grid/col"

export interface TextareaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, ...props }, ref) => {
    return (
      <textarea
        className={cn(
          "flex min-h-[60px] w-full rounded-md border border-input bg-transparent px-3 py-2 text-sm shadow-sm placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)
Textarea.displayName = "Textarea"

interface FormikTextAreaProps extends TextareaProps {
  icon?: React.ReactNode;
  size?: number;
  label?: string;
  field?: any;
  showError?: boolean;
  loading?: boolean;
}

export const FormikTextArea = ({showError=true,...props}: FormikTextAreaProps) => {
  const formikProps = useFormikContext<any>();
  const {values, setFieldValue, setFieldTouched, handleChange, handleBlur} = formikProps;
  const name = props.field?.name || props.name;
  const errorMessage = useFieldError(name);
  const error = !!errorMessage;
  const { icon, loading, label, size, field, ...textareaProps } = props;

  var component = (
    <>
    {label && (
      <Label htmlFor={name}>{label}</Label>
    )}
    <Textarea
      {...textareaProps}
      id={props.id || name}
      name={name}
      aria-invalid={error}
      className={cn(error && FIELD_ERROR_CLASS, props.className)}
      value={props.value || values[name]} 
      onBlur={handleBlur}
      onChange={handleChange} 
      />
    {showError && <FieldErrorMessage message={errorMessage} />}
    </>
  );

  if (props.size){
    return <Col xs={12} sm={props.size}>{component}</Col>
  }


  return component;
}

export { Textarea }
